'use client';

import { useState } from 'react';

type UnpublishedPlaceholderProps = {
  message: string;
};

export const UnpublishedPlaceholder = ({
  message,
}: UnpublishedPlaceholderProps) => {
  const [show, setShow] = useState(true);

  if (show) {
    return (
      <div
        data-testid='common-carousel-unpublished-placeholder'
        className='w-full h-10 rounded bg-orangeHover mb-4 py-1 px-2 flex items-center justify-between text-white font-bold text-xl uppercase'
      >
        <span>{message}</span>
        <button
          aria-label='close placeholder button'
          className='button rotate-45 text-4xl font-normal cursor-pointer'
          onClick={() => {
            setShow(false);
          }}
        >
          +
        </button>
      </div>
    );
  }

  return null;
};
